import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {preSave, IDomainObject, FormProps, ClosedContentProps} from "core/form/formUtils";
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {computeHeight} from "core/common/utils/domUtils";
import {debounce} from "core/common/utils/utils";
import {GridSpecialCondition} from "core/grid/domain/gridSpecialCondition";
import {ObservableMap, action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import uiService from "core/common/service/uiService";
import {ZzFlatButton} from "core/components/buttons/buttons";
import {observer} from "mobx-react";
import {removeItemFromLocalStorage} from "core/common/utils/storage";
import {FIELDDEFDISPLAYTYPE} from "core/form/form";
import {loc} from "core/common/config/locales";


let AceEditor;


interface GridSpecialConditionDetailState {
  aceHeightBody: number;
}


@observer
export default class GridSpecialConditionDetail extends PageAncestor<PageProps, GridSpecialConditionDetailState> {

  static module = MODULE.core;
  static title = 'Special Condidition';
  static icon = 'wrench';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("GridSpecialConditionDetail#fetchData(%o)", routerParams);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['GridSpecialCondition']);

    let specialConditionPromise: Promise<GridSpecialCondition>;

    if (routerParams.id === 'new') {
      specialConditionPromise = Promise.resolve(new GridSpecialCondition(Object.assign({$new: true}, query)));
    } else if (routerParams.id === 'copy') {
      specialConditionPromise = gridService.readSpecialCondition(query.copyId)
      .then(specialCondition => {
        specialCondition.cleanOnCopy();
        return specialCondition;
      });
    } else {
      specialConditionPromise = gridService.readSpecialCondition(routerParams.id);
    }

    return Promise.all([metadataPromise, specialConditionPromise])
      .then( ([entityMap, specialCondition]: [ObservableMap<MdEntity>, GridSpecialCondition]) => {
        gridService.specialConditionObject = specialCondition.initAfterRead(routerParams.id === 'new');
        if (gridService.specialConditionObject.sql == null) gridService.specialConditionObject.sql = '';
      });
  }


  state = {
    aceHeightBody: 400
  };

  onResizeDebounced: any;

  _aceEditorBody: React.ReactInstance;


  componentWillMount() {
    require.ensure(['react-ace', 'brace', 'brace/mode/sql', 'brace/theme/github', 'brace/ext/searchbox'], (require) => {
      if (AceEditor) {
        return;
      }

      AceEditor = (require('react-ace') as any).default;
      const brace = require("brace");
      require('brace/mode/sql');
      require('brace/theme/github');
      require('brace/ext/searchbox');


      this.forceUpdate();
      this.onResize();

    }, "reactAce");
  }


  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    this.onResizeDebounced = debounce(this.onResize, 15, false);
    window.addEventListener('resize', this.onResizeDebounced);
    this.onResize();
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeDebounced);
    gridService.specialConditionObject = null;
  }


  onResize = (evt?) => {
    let bodyRect = document.body.getBoundingClientRect();

    let aceHeightBody = computeHeight(bodyRect, this._aceEditorBody);

    console.debug("onResize: " + aceHeightBody);

    if (aceHeightBody) {
      this.setState({aceHeightBody: aceHeightBody});
    }
  };



  /* ****************   EVENT HENDLERS ************************************************************ */

  customValidate = (specialCondition) => {
    let errors = [];
    return errors;
  };

  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(gridService.specialConditionObject, this.customValidate);
    if (!result) {
      return;
    }

    gridService.saveSpecialCondition(gridService.specialConditionObject)
      .then(action("saveSpecialCondition-action", (specialConditionJson: IDomainObject) => {

        let wasNew = gridService.specialConditionObject.cleanAfterSave(specialConditionJson);
        if (wasNew) {
          this.context.router.replaceWith('gridSpecialConditionDetail', {id: gridService.specialConditionObject.id});
        }
        uiService.hideToolbarActionFlag();

        gridService.removeGrid(gridService.specialConditionObject.gridLocation);
        removeItemFromLocalStorage("GridLocation", loc.lang, gridService.specialConditionObject.gridLocation);
      }));

  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    gridService.deleteSpecialCondition(gridService.specialConditionObject.specialConditionId)
      .then(response => {

        gridService.removeGrid(gridService.specialConditionObject.gridLocation);
        removeItemFromLocalStorage("GridLocation", loc.lang, gridService.specialConditionObject.gridLocation);
        this.onBack();
      }, error => {
        gridService.specialConditionObject.$errors = error.getMessages();
      });
  };


  onAdd = (evt) => {
    console.log('onAdd');
    let query = {};
    this.context.router.transitionTo("gridSpecialConditionDetail", {id: 'new'}, query);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("gridSpecialConditionDetail", {id: 'copy'}, {copyId: gridService.specialConditionObject.specialConditionId});
  };




  onBack = () => {
    console.log('onClickBack');
    let query = {};
    this.context.router.transitionTo("gridLocationDetail", {id: gridService.specialConditionObject.gridLocation}, query);
  };

  onChangeSql = (newValue) => {
    console.log('onChangeSql');
    gridService.specialConditionObject.sql = newValue;
    gridService.specialConditionObject.$dirty = true;
  };


  /* ****************   REACT METHODS ************************************************************ */

  render() {
    let {
      query
      } = this.props;

    return (
      <main className="main-content container">
        {this._createToolMenu(gridService.specialConditionObject, query.gridLocation)}
        <form style={{marginTop: 10}}>
          <GridSpecialConditionForm dataObject={gridService.specialConditionObject} rootObject={gridService.specialConditionObject} entity={mdEntityService.getEntity('GridSpecialCondition')} entities={mdEntityService.entityMap}/>

          <h5>Where condition SQL</h5>
          <div className="row">
            <div className="col-xs-12">
              { (AceEditor) ?
                <AceEditor
                  mode="sql"
                  theme="github"
                  value={gridService.specialConditionObject.sql}
                  onChange={this.onChangeSql}
                  name="SQL"
                  enableBasicAutocompletion={true}
                  enableLiveAutocompletion={true}
                  editorProps={{$blockScrolling: true}}
                  width="100%"
                  height={this.state.aceHeightBody + 'px'}
                  style={{padding: '5px 0 0 0'}}
                  ref={(c) => this._aceEditorBody = c}
                />
                : "Loading...."}
            </div>
          </div>

        </form>
      </main>

    );
  }

  /* ****************   NORMAL METHODS ************************************************************ */


  _createToolMenu(specialCondition, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack}>
          <ZzFlatButton onClick={this.onSave} disabled={!specialCondition.$dirty} label="Save" permission={specialCondition.$new ? PERMISSION.New : PERMISSION.Update}/>
          <ZzFlatButton onClick={this.onAdd} disabled={specialCondition.$new} label="New" permission={PERMISSION.New}/>
          <ZzFlatButton onClick={this.onCopy} disabled={specialCondition.$new} label="Copy" permission={PERMISSION.New}/>
          <ZzFlatButton onClick={this.onDelete} disabled={specialCondition.$new} label="Delete" permission={PERMISSION.Delete}/>
      </Toolmenu>
    );
  }

}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<GridSpecialCondition>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <h5 style={{marginTop: 0, fontSize: '18px', fontWeight: 'bold'}}> {dataObject.name}</h5>
    <div>{dataObject.description}</div>
  </div>
);

@createForm({
  formName: 'GridSpecialConditionForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'description',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }]
}, ClosedContent)
@observer
class GridSpecialConditionForm extends React.Component<FormProps<GridSpecialCondition, GridSpecialCondition>, undefined> {

  render() {

    let {dataObject, rootObject, entities, formName, entity} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, description, sql} = fields;

    let openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...name.props}/>
            <Validate field={name} value={name.props.value}/>
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...description.props} multiLine rows={2}/>
          </div>
        </div>
      </div>
    );


    return (
      <BlockComp noPadding>
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />}
                    validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/grid/gridSpecialConditionDetail.tsx